import { graphql, useStaticQuery } from 'gatsby'

export type UseSiteMetadataReturnType = {
  siteUrl?: string
  logoUrl?: string
  logoAbsoluteUrl?: string
}

const useSiteData = (): UseSiteMetadataReturnType => {
  const { site, logo } = useStaticQuery<GatsbyTypes.SiteDataQuery>(graphql`
    query SiteData {
      site {
        siteMetadata {
          siteUrl
        }
      }
      logo: file(name: { eq: "logo-horizontal" }) {
        publicURL
      }
    }
  `)

  const siteUrl = site?.siteMetadata?.siteUrl
  const logoUrl = logo?.publicURL
  const logoAbsoluteUrl = siteUrl && logoUrl ? `${siteUrl}${logoUrl}` : undefined

  return {
    siteUrl,
    logoUrl,
    logoAbsoluteUrl
  }
}

export default useSiteData
